(function() {
  function injectHomeIcon() {
    var links = document.querySelectorAll('.navigation__link[href="/"]');
    links.forEach(function(link) {
      if (link.classList.contains('navigation__link--home')) return;
      link.classList.add('navigation__link--home');
      link.setAttribute('aria-label', 'Home');
      link.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 12L3 12L12 3L21 12L19 12" /><path d="M5 12V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V12" /><path d="M9 21V15C9 14.4696 9.21071 13.9609 9.58579 13.5858C9.96086 13.2107 10.4696 13 11 13H13C13.5304 13 14.0391 13.2107 14.4142 13.5858C14.7893 13.9609 15 14.4696 15 15V21" /></svg>';
    });
  }

  function forceGridView() {
    try { localStorage.setItem('cc-col-layout', '2'); } catch(e) {}
    var gridBtns = document.querySelectorAll('.layout-switch--two-columns');
    var listBtns = document.querySelectorAll('.layout-switch--one-column');
    gridBtns.forEach(function(btn) { btn.classList.add('layout-switch--active'); });
    listBtns.forEach(function(btn) { btn.classList.remove('layout-switch--active'); });
    var grids = document.querySelectorAll('.product-grid');
    grids.forEach(function(grid) {
      grid.classList.remove('product-grid--per-row-mob-1');
      grid.classList.add('product-grid--per-row-mob-2');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { injectHomeIcon(); forceGridView(); });
  } else {
    injectHomeIcon(); forceGridView();
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.querySelector && node.querySelector('.navigation__link[href="/"]')) injectHomeIcon();
        if (node.classList && node.classList.contains('navigation__link') && node.getAttribute('href') === '/') injectHomeIcon();
        if (node.querySelector && node.querySelector('.layout-switch')) forceGridView();
        if (node.querySelector && node.querySelector('.product-grid')) forceGridView();
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
